import React, { Component } from 'react';

import cn from 'classnames';
import styles from './styles.scss';

import BuildingCard from '../BuildingCard';
import Footer from 'components/Footer';

import { Helmet } from 'react-helmet';

import { connect } from 'react-redux';
import { setPopUp } from 'actions/environment';
import { loadFavorites, removeFromFavorites } from 'actions/favorites';
import nothingFound from 'assets/images/nothingfound@2x.png';
import { pluralize } from 'utils';
import withValidTrafic from 'decorators/withValidTrafic';
import { withTranslation } from 'react-i18next';

@withValidTrafic()
class Favorites extends Component {

  componentDidMount() {
    this.props.loadFavorites({
      userUid: this.props.userUid
    });
  }

  handleChange = (e) => {
    this.setState({
      newCollectionName: e.target.value
    });
  }

  handleDeleteClick = (building) => {
    const { id, title } = building;
    this.props.removeFromFavorites(
      {
        buildingId: id,
        userUid: this.props.userUid
      },
      {
        buildingName: title,
        data: building
      }
    );
  }

  render() {
    const { className, favorites, t } = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {t('components.favorites.title')}
          </title>
        </Helmet>
        {
            favorites ? (
              <div>
                {favorites.length ? (
                  <div className={cn(styles.Collections, className)}>
                    <div className={styles.Container}>
                      <div className={styles.TitleBlock}>
                        <p className={styles.Title}>
                          {t('components.favorites.titleBlock')}
                        </p>
                        <span className={styles.FavoritesCount}>
                          {favorites.length} {pluralize(favorites.length, t('components.favorites.titleBlock'), t('components.favorites.titleBlock'), t('components.favorites.titleBlock'))}
                        </span>
                      </div>
                      <div className={styles.List}>
                        {
                          favorites && favorites.map(
                            (favorite) => (
                              <BuildingCard
                                {...favorite}
                                key={favorite.id}
                                className={styles.BuildingCard}
                                deleteText={t('components.favorites.remove')}
                                handleDeleteClick={this.handleDeleteClick}
                                withLabels
                              />
                            )
                          )
                        }
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={cn(styles.Collections, className)}>
                    <div className={styles.Container}>
                      <div className={styles.TitleBlock}>
                        <p className={styles.Title}>
                          {t('components.favorites.titleBlock')}
                        </p>
                      </div>
                      <div className={styles.NotFoundBlock}>
                        <div className={styles.NotFoundMain}>
                          <p className={styles.NotFoundTitle}>
                            {t('components.favorites.empty')}
                          </p>
                          <p className={styles.NotFoundText}>
                            {t('components.favorites.notFound')}
                          </p>
                        </div>
                        <div className={styles.NotFoundImage}>
                          <img src={nothingFound} alt="nothing found" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <Footer />
              </div>
            ) : (
              <div className={styles.Wireframe}>
                <div className={styles.Container}>
                  <div className={styles.TitleBlock}>
                    <p className={styles.Title}>
                      {t('components.favorites.titleBlock')}
                    </p>
                  </div>
                  <div className={styles.WireframeLoaderWrap}>
                    <div className={styles.WireframeLoader} />
                  </div>
                </div>
              </div>
            )
          }
      </React.Fragment>
    );
  }
}

export default connect(
  state => ({
    userUid: state.profile.hash,
    favorites: state.favorites.buildings
  }),
  { setPopUp, loadFavorites, removeFromFavorites }
)(withTranslation()(Favorites));



// WEBPACK FOOTER //
// ./src/components/Favorites/Favorites.js